<!-- <template>
  <div class="features-page">
    <h2 class="subtitle">Why Should You Choose MedLab?</h2>
    <h1 class="title">Our Features List</h1>
    <div class="underline"></div>

    <div class="features-grid">
      <div
        v-for="(feature, index) in features"
        :key="index"
        class="feature-card"
      >
        <div class="feature-icon">
           <img v-if="feature.image" :src="feature.image" :alt="feature.title" />
        </div>
        <h2>{{ feature.title }}</h2>
        <p>{{ feature.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FeaturesPage",
  data() {
    return {
      features: [
        {
          title: "Browser-Based App",
          description: "Accessible on any device including smartphone, tablet, or laptop as it runs on any modern browser.",
          image: require("@/assets/icons/browser_based.svg")
          
        },
        {
          title: "Online / Offline Availability",
          description: "Works seamlessly both online and offline, ensuring uninterrupted access regardless of internet availability.",
          image: require("@/assets/icons/Online_offline.svg")
        },
        {
          title: "PDF Report",
          description: "Download test reports in PDF format for fast, easy sharing.",
          image: require("@/assets/icons/PDF.svg")
        },
        {
          title: "Abnormal Validation",
          description: "Highlights out-of-range results instantly for better accuracy.",
          image: require("@/assets/icons/Abnormal.svg")
        },
        {
          title: "Barcode Reader",
          description: "Scan barcodes for quick and error-free sample entry.",
          image: require("@/assets/icons/barcode.svg")
        },
        {
          title: "Training Video",
          description: "Module-based training videos are available to learn advanced features.",
          image: require("@/assets/icons/Tutorial.svg")
        },
        {
          title: "Design Assistance",
          description: "Help in creating personalized logos, posters, and lab report designs reflecting your unique style.",
          image: require("@/assets/icons/Design_assistance.svg")
        },
        {
          title: "Result Auto Calculation",
          description: "Boosts efficiency with auto-calculations.",
          image: require("@/assets/icons/Autocalculate.svg")
        },
        {
          title: "Lab - Machine Integration",
          description: "Automatically integrate lab analysers with the software for fast, accurate, error-free result entry.",
          image: require("@/assets/icons/machine_lab_integration.svg")
        },
        {
          title: "Test Packages Management",
          description: "Group multiple tests into packages for quick billing and reporting.",
          image: require("@/assets/icons/Package_management.svg")
        },
        {
          title: "WhatsApp Direct Report Share",
          description: "Instantly share reports via WhatsApp Web for faster, seamless communication.",
          image: require("@/assets/icons/whatsapp.svg")
        },
        {
          title: "Finance Module",
          description: "Simplifies billing, payments, and financial summaries.",
          image: require("@/assets/icons/Finance.svg")
        }
      ]
    };
  }
};
</script>

<style scoped>
.features-page {
  padding: 60px 40px;
  text-align: center;
  background: #fff;
  gap: 10px;
}

.subtitle {
  font-size: 1.2rem;
  font-weight: 500;
  margin-bottom: 10px;
  color: #444;
}

.title {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 50px;
  color: #206A98;
}
.underline {
  width: 10%;
  height: 3px;
  background: #206A98;
  margin: 0 auto 40px;
  border-radius: 2px;
}
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px 60px;
  max-width: 1200px;
  margin: 0 auto;
}

.feature-card {
  text-align: center;
}


 .feature-icon {
  background: #206A98;
  color: #fff;
  font-size: 24px;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
 .feature-icon img {
  width: 40px; 
  height: auto;
  margin-bottom: 0px;
}


.feature-card h2 {
  font-size: 1.1rem;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.feature-card p {
  font-size: 0.95rem;
  color: #666;
  line-height: 1.5;
  max-width: 280px;
  margin: 0 auto;
}
/* Responsive */
@media (max-width: 768px) {
  .title {
    font-size: 1.6rem;
    margin-bottom: 30px;
  }
  .features-grid {
    gap: 30px;
  }
   .testimonial-content {
    flex-direction: column;
    text-align: center;
  }
  .testimonial-text {
    text-align: center;
  }
  .testimonial-image {
    justify-content: center;
    margin-top: 30px;
  }
  .testimonial-image img {
    max-width: 300px;
  }
}
</style> -->

<template>
  <div class="features-page">
    <!-- 🌟 Overlay (mobile view only) -->
    <div class="features-overlay"></div>

    <h2 class="subtitle">Why Should You Choose MedLab?</h2>
    <h1 class="title">Our Features List</h1>
    <div class="underline"></div>

    <div class="features-grid">
      <div
        v-for="(feature, index) in features"
        :key="index"
        class="feature-card"
      >
        <div class="feature-icon">
          <img v-if="feature.image" :src="feature.image" :alt="feature.title" />
        </div>
        <h2>{{ feature.title }}</h2>
        <p>{{ feature.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FeaturesPage",
  data() {
    return {
      features: [
        {
          title: "Browser-Based App",
          description:
            "Accessible on any device including smartphone, tablet, or laptop as it runs on any modern browser.",
          image: require("@/assets/icons/browser_based.svg"),
        },
        {
          title: "Online / Offline Availability",
          description:
            "Works seamlessly both online and offline, ensuring uninterrupted access regardless of internet availability.",
          image: require("@/assets/icons/Online_offline.svg"),
        },
        {
          title: "PDF Report",
          description: "Download test reports in PDF format for fast, easy sharing.",
          image: require("@/assets/icons/PDF.svg"),
        },
        {
          title: "Abnormal Validation",
          description: "Highlights out-of-range results instantly for better accuracy.",
          image: require("@/assets/icons/Abnormal.svg"),
        },
        {
          title: "Barcode Reader",
          description: "Scan barcodes for quick and error-free sample entry.",
          image: require("@/assets/icons/barcode.svg"),
        },
        {
          title: "Training Video",
          description:
            "Module-based training videos are available to learn advanced features.",
          image: require("@/assets/icons/Tutorial.svg"),
        },
        {
          title: "Design Assistance",
          description:
            "Help in creating personalized logos, posters, and lab report designs reflecting your unique style.",
          image: require("@/assets/icons/Design_assistance.svg"),
        },
        {
          title: "Result Auto Calculation",
          description: "Boosts efficiency with auto-calculations.",
          image: require("@/assets/icons/Autocalculate.svg"),
        },
        {
          title: "Lab - Machine Integration",
          description:
            "Automatically integrate lab analysers with the software for fast, accurate, error-free result entry.",
          image: require("@/assets/icons/machine_lab_integration.svg"),
        },
        {
          title: "Test Packages Management",
          description: "Group multiple tests into packages for quick billing and reporting.",
          image: require("@/assets/icons/Package_management.svg"),
        },
        {
          title: "WhatsApp Direct Report Share",
          description: "Instantly share reports via WhatsApp Web for faster, seamless communication.",
          image: require("@/assets/icons/whatsapp.svg"),
        },
        {
          title: "Finance Module",
          description: "Simplifies billing, payments, and financial summaries.",
          image: require("@/assets/icons/Finance.svg"),
        },
      ],
    };
  },
};
</script>

<style scoped>
.features-page {
  position: relative; 
  padding: 60px 40px;
  text-align: center;
  background: #fff;
  gap: 10px;
  overflow: hidden; 
}


.features-overlay {
  display: none;
}

.subtitle {
  font-size: 1.2rem;
  font-weight: 500;
  margin-bottom: 10px;
  color: #444;
}

.title {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 50px;
  color: #206A98;
}

.underline {
  width: 10%;
  height: 3px;
  background: #206A98;
  margin: 0 auto 40px;
  border-radius: 2px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px 60px;
  max-width: 1200px;
  margin: 0 auto;
}

.feature-card {
  text-align: center;
}

.feature-icon {
  background: #206A98;
  color: #fff;
  font-size: 24px;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-icon img {
  width: 40px;
  height: auto;
  margin-bottom: 0px;
}

.feature-card h2 {
  font-size: 1.1rem;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.feature-card p {
  font-size: 0.95rem;
  color: #666;
  line-height: 1.5;
  max-width: 280px;
  margin: 0 auto;
}

/* 📱 Responsive */
@media (max-width: 768px) {
  .title {
    font-size: 1.6rem;
    margin-bottom: 30px;
  }
  .features-grid {
    gap: 30px;
  }
}

/* 📱 Mobile view (≤480px) */
@media (max-width: 480px) {
  .features-page {
    padding: 40px 20px;
  }

 
  .features-overlay {
    display: block;
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.45); 
    backdrop-filter: blur(4px); 
  }

  /* ✅ Keep content above overlay */
  .subtitle,
  .title,
  .underline,
  .features-grid {
    position: relative;
    z-index: 2;
  }
}
</style>






